import { useCallback, useEffect, useState } from "react";

import { useResize } from "@is/hooks";

export function useScreenOrientation() {
  const [isPortraitView, setIsPortraitView] = useState(
    window.innerWidth < window.innerHeight
  );

  const updateOrientation = useCallback(() => {
    setIsPortraitView(window.innerWidth < window.innerHeight);
  }, []);

  useResize(updateOrientation);

  useEffect(() => {
    updateOrientation();
  }, [updateOrientation]);

  const isLandscapeView = !isPortraitView;

  return { isPortraitView, isLandscapeView };
}
